module.exports = __webpack_public_path__ + "assets/img/yixiangdan.d9f39db6.png";